var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoeAdminLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#paint0_linear_4616_4275)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 36V14.6667C28.8 13.9594 28.5471 13.2811 28.0971 12.781C27.647 12.281 27.0365 12 26.4 12H21.6C20.9635 12 20.353 12.281 19.9029 12.781C19.4529 13.2811 19.2 13.9594 19.2 14.6667V36M14.4 17.3333H33.6C34.9255 17.3333 36 18.5272 36 20V33.3333C36 34.8061 34.9255 36 33.6 36H14.4C13.0745 36 12 34.8061 12 33.3333V20C12 18.5272 13.0745 17.3333 14.4 17.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4616_4275",
    x1: -67.5,
    y1: -30,
    x2: 4.47661,
    y2: -59.2178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F2D7F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoeAdminLoginIcon);
export default __webpack_public_path__ + "static/media/coe-admin-login-icon.028e1bcede97d38c4bb6b4212cc3ba7f.svg";
export { ForwardRef as ReactComponent };